import { Filter } from "../entityTable/Filter";

export interface IUserPreferencesService {
    getPreferences: (userId?: number) => Promise<IUserPreferences | null>;
    savePreferences: (req: SavePreferencesRequest) => Promise<void>;
    clearPreferences: (req: ClearPreferencesRequest) => Promise<void>;
}

export type UserPreferenceTypes = "entityTables";
export const UserPreferenceTypes = {
    ENTITY_TABLES: "entityTables",
} as const;

export interface SavePreferencesRequest {
    preference: keyof IUserPreferences;
    key: string;
    value: any;
    appName: string;
    userId?: number;
}

export interface ClearPreferencesRequest {
    preference: keyof IUserPreferences;
    predefinedEntityTableViewId?: PredefinedEntityTableViewId;
    predefinedEntityTableView?: PredefinedEntityTableView | null;
    key: string;
    appName: string;
    userId?: number;
}
export interface DeletePreferencesRequest {
    preference: keyof IUserPreferences;
    predefinedEntityTableViewId?: PredefinedEntityTableViewId;
    isAdminView?: boolean;
    key: string;
    appName: string;
    userId?: number;
}

export type IUserPreferences = {
    [key in UserPreferenceTypes]: Record<string, IUserTablePreferences>;
};

export interface IUserTablePreferences {
    sortModel?: GridSortItem[];
    columns?: any[];
    pageSize?: number;
    columnVisibilityModel?: any;
    columnOrder?: string[];
    pinnedColumns?: any;
    predefinedEntityTableViews?: PredefinedEntityTableView[];
    predefinedEntityTableViewsOrder?: string[];
    selectedPredefinedEntityTableViewId?: PredefinedEntityTableViewId;
}

interface GridSortItem {
    field: string;
    sort: "asc" | "desc";
}

export type PredefinedEntityTableView = {
    id: PredefinedEntityTableViewId;
    name: string;
    description?: string;
    colorChanged: boolean;
    color: string;
    isAdministratorView: boolean;
    entityName: string;
    isStatmapView: boolean;
    customFilter: Filter<any> | null | undefined;
    filterModel: GridFilterModel;
    clientQuery: any;
    columns?: any[];
    pageSize?: number;
    columnVisibilityModel?: any;
    columnOrder?: string[];
    pinnedColumns?: any;
};

export type PredefinedEntityTableViewId = string;

interface GridFilterModel {
    /**
     * @default []
     */
    items: GridFilterItem[];
    /**
     * - `GridLogicOperator.And`: the row must pass all the filter items.
     * - `GridLogicOperator.Or`: the row must pass at least on filter item.
     * @default `GridLogicOperator.Or`
     */
    logicOperator?: GridLogicOperator;
    /**
     * values used to quick filter rows
     * @default `[]`
     */
    quickFilterValues?: any[];
    /**
     * - `GridLogicOperator.And`: the row must pass all the values.
     * - `GridLogicOperator.Or`: the row must pass at least one value.
     * @default `GridLogicOperator.And`
     */
    quickFilterLogicOperator?: GridLogicOperator;
    /**
     * If `true`, the quick filter will skip cell values from hidden columns.
     * @default false
     */
    quickFilterExcludeHiddenColumns?: boolean;
}

interface GridFilterItem {
    /**
     * Must be unique.
     * Only useful when the model contains several items.
     */
    id?: number | string;
    /**
     * The column from which we want to filter the rows.
     */
    field: string;
    /**
     * The filtering value.
     * The operator filtering function will decide for each row if the row values is correct compared to this value.
     */
    value?: any;
    /**
     * The name of the operator we want to apply.
     */
    operator: string;
}
declare enum GridLogicOperator {
    And = "and",
    Or = "or",
}
